import { AppInfo, ConnectedServices } from '../../types/app/appInfo.types';
import { api } from '../core/api';

export const getAppInfo = () => api.get<AppInfo>('Common/AppInfo').then((res) => res.data);

export const getConnectedServices = () =>
  api.get<ConnectedServices>('Common/ConnectedServices').then((res) => res.data);

export const useHydraDataService = () =>
  api.get<boolean>('Common/UseHydraDataService').then((res) => res.data);
